import React from "react";

export const ValidationNumbers = (string: string) => {
    return /^[0-9]+$/.test(string);
};

export const ValidationPassword = (string: string) => {
    return /^(?=.*\d)(?=.*[A-Z])(?=.*\W)[a-zA-Z0-9\S]{8,}$/.test(string);
};

export const ValidationNumbers4D = (string: string) => {
    return /^[0-9]+(?:\.\d{0,4})?$/.test(string);
};

export const ValidationEmail = (string: string) => {
    return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(
        string
    );
};

export const ValidationCurp = (string: string) => {
    return /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/.test(
        string
    );
};
export const ValidationRfc = (string: string) => {
    return /^([A-ZÑ\x26]{4,5}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{2,3}))?$/.test(
        string
    );
};

export const ValidationEmpty = (value: string) => {
    return value !== "";
};

export const ValidationSelect = (value: any) => {
    return !!value;
};

export const ValidationOneUpper = (string: string) => {
    return /[A-Z]/.test(string);
};
export const ValidationOneLower = (string: string) => {
    return /[a-z]/.test(string);
};

export const ValidationOneNumber = (string: string) => {
    return /[0-9]+/.test(string);
};

export const ValidationZiseString = (string: string | any[], limit: number) => {
    if (string) {
        return string.length >= limit;
    }
};

export const ValidationZiseStringExact = (string: string | any[], limit: any) => {
    if (string) {
        if (string.length === limit) {
            return true;
        }
    }

    return false;
};

export const ValidationZiseStringEqual = (string: string | any[], limit: any) => {
    if (string) {
        return string.length === limit;
    }
};

export const UpdateValue = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
    inputList: any,
    setInputList: (arg0: any) => void
) => {
    e.preventDefault();

    const newValue = e.target.value;

    if (id === "datePick") {
        let inputCopy = { ...inputList };
        inputCopy[id].value = newValue;
        setInputList(inputCopy);
    } else {
        let inputCopy = { ...inputList };
        inputCopy[id].value = newValue;
        setInputList(inputCopy);
    }
};


export const UpdateValueStaking = (e: { preventDefault: () => void; value: any; target: { value: any; }; }, id: string | number, counter: string | number, inputList: any, setInputList: (arg0: any[]) => void) => {
    e.preventDefault();
    if (e?.value) {
        let inputCopy = [...inputList];
        // @ts-ignore
        inputCopy[counter][id].value = e.value;
        setInputList(inputCopy);
    } else {
        let inputCopy = [...inputList];
        // @ts-ignore
        inputCopy[counter][id].value = e.target.value;
        setInputList(inputCopy);
    }
};


export const ColorValidation = (
    propertyName: string,
    inputList: { [x: string]: { value: any; }; },
    validationType = "empty",
    _multipleValidations: any,
    limit: number
) => {
    let validationFunction: (value: any, limit: number) => boolean;

    switch (validationType) {
        case "number":
            validationFunction = ValidationNumbers;
            break;
        case "number4D":
            validationFunction = ValidationNumbers4D;
            break;
        case "email":
            validationFunction = ValidationEmail;
            break;
        case "empty":
            validationFunction = ValidationEmpty;
            break;
        case "select":
            validationFunction = ValidationSelect;
            break;
        case "multiple":
            validationFunction = ValidationSelect;
            break;
        case "optional":
            validationFunction = () => true;
            break;
        case "curp":
            validationFunction = ValidationCurp;
            break;
        case "rfc":
            validationFunction = ValidationRfc;
            break;
        case "validationSize":
            validationFunction = ValidationZiseStringExact;
            break;
        case "validationSizeStr":
            // @ts-ignore
            validationFunction = ValidationZiseString;
            break;
        default:
            validationFunction = ValidationEmpty;
    }

    const codeElement = document.getElementById(propertyName);
    const obligatoryElement = document.getElementById(propertyName + "obligatorio");

    let result = validationFunction(inputList[propertyName].value, limit);

    if (!result && inputList[propertyName].value != null) {
        try {
            if (codeElement) {
                codeElement.style.border = '2px solid red';
            }
            if (obligatoryElement) {
                obligatoryElement.style.color = 'red';
            }
        } catch (error) {
            console.error('Error applying styles:', error);
        }
    } else {
        try {
            if (validationType === "select") {
                if (codeElement) {
                    codeElement.style.border = '1px solid transparent';
                }
                if (obligatoryElement) {
                    obligatoryElement.style.color = '#c1c1c1';
                }
            } else {
                if (codeElement) {
                    codeElement.style.border = '1px solid #ccc';
                }
                if (obligatoryElement) {
                    obligatoryElement.style.color = '#a0a0a3';
                }
            }
        } catch (error) {
            console.error('Error applying styles:', error);
        }
    }
};


export const SubmitValidation = (inputList: any, setInputList: any) => {
    let noErrors = true;

    for (const inputName in inputList) {
        if (
            inputList[inputName].value === null &&
            inputList[inputName].validationType !== "optional"
        ) {
            let inputCopy = {...inputList};
            inputCopy[inputName].value = "";
            setInputList(inputCopy);
        }

        if (inputList[inputName].validationType) {
            switch (inputList[inputName].validationType) {
                case "number":
                    if(!ValidationNumbers(inputList[inputName].value)) {
                        noErrors = false
                    }
                    break;
                case "email":
                    if(!ValidationEmail(inputList[inputName].value)) {
                        noErrors = false
                    }
                    break;
                case "empty":
                    if(!ValidationEmpty(inputList[inputName].value)) {
                        noErrors = false
                    }
                    break;
                case "select":
                    if(!ValidationSelect(inputList[inputName])) {
                        noErrors = false
                    }
                    break;
                case "curp":
                    if(!ValidationCurp(inputList[inputName].value)) {
                        noErrors = false
                    }
                    break;
                case "rfc":
                    if(!ValidationRfc(inputList[inputName].value)) {
                        noErrors = false
                    }
                    break;
                case "validationSize":
                    if(!ValidationZiseStringExact(
                        inputList[inputName].value,
                        inputList[inputName].limit
                    )) {
                        noErrors = false
                    }
                    break;
                case "validationSizeStr":
                    if (ValidationZiseString(
                        inputList[inputName].value,
                        inputList[inputName].limit
                    )) {
                        noErrors = false
                    }
                    break;
            }
        } else {
            try {
                // this is for the stacking inputs validations, FIX THIS IN POSTERIOR VERSIONS to only use 1 switch
                switch (inputList[inputName].type[0]) {
                    case "number":
                        if (!ValidationNumbers(inputList[inputName].value)) {
                            noErrors = false;
                        }
                        break;
                    case "email":
                        if(!ValidationEmail(inputList[inputName].value)){
                            noErrors = false
                        }
                        break;
                    case "empty":
                        if(!ValidationEmpty(inputList[inputName].value)) {
                            noErrors = false
                        }
                        break;
                    case "select":
                        if(!ValidationSelect(inputList[inputName])) {
                            noErrors = false
                        }
                        break;
                    case "curp":
                        if(!ValidationCurp(inputList[inputName].value)) {
                            noErrors = false
                        }
                        break;
                    case "rfc":
                        if(!ValidationRfc(inputList[inputName].value)) {
                            noErrors = false
                        }
                        break;
                    case "validationSize":
                        if(!ValidationZiseStringExact(
                            inputList[inputName].value,
                            inputList[inputName].limit
                        )) {
                            noErrors = false
                        }
                        break;
                    case "validationSizeStr":
                        if(!ValidationZiseString(
                            inputList[inputName].value,
                            inputList[inputName].limit
                        )) {
                            noErrors = false
                        }
                        break;
                }
            } catch (e) {
            }
        }
    }
    return noErrors;
};
export const SubmitValidationStaking = (
    inputList: string | any[],
    setInputList: (arg0: any[]) => void,
    limit: any
) => {
    let noErrors = true;
    for (let i = 0; i < inputList.length; i++) {

        for (const inputName in inputList[i]) {
            if (
                inputList[i][inputName].value === null &&
                inputList[i][inputName].validationType !== "optional"
            ) {
                // @ts-ignore
                let inputCopy = [...inputList];
                inputCopy[i][inputName].value = "";
                setInputList(inputCopy);
            }

            if (inputList[i][inputName].validationType) {
                switch (inputList[i][inputName].validationType) {
                    case "number":
                        if(!ValidationNumbers(inputList[i][inputName].value)) {
                            noErrors = false
                        }
                        break;
                    case "email":
                        if(!ValidationEmail(inputList[i][inputName].value)) {
                            noErrors = false
                        }
                        break;
                    case "empty":
                        if(!ValidationEmpty(inputList[i][inputName].value)) {
                            noErrors = false
                        }
                          break;
                    case "select":
                        if(!ValidationSelect(inputList[i][inputName])) {
                            noErrors = false
                        }
                        break;
                    case "curp":
                        if(!ValidationCurp(inputList[i][inputName].value)) {
                            noErrors = false
                        }
                        break;
                    case "rfc":
                        if(!ValidationRfc(inputList[i][inputName].value)) {
                            noErrors = false
                        }
                        break;
                    case "validationSize":
                        if(!ValidationZiseStringExact(
                            inputList[i][inputName].value,
                            inputList[i][inputName].limit
                        )) {
                            noErrors = false
                        }
                        break;
                    case "validationSizeStr":
                        if(!ValidationZiseString(
                            inputList[i][inputName].value,
                            inputList[i][inputName].limit
                        )) {
                            noErrors = false
                        }
                        break;
                }
            } else {
                try {
                    // this is for the stacking inputs validations, FIX THIS IN POSTERIOR VERSIONS to only use 1 switch
                    // @ts-ignore
                    switch ([i][inputName].type[0]) {
                        case "number":
                            if(!ValidationNumbers(inputList[i][inputName].value)) {
                                noErrors = false
                            }
                            break;
                        case "email":
                            if(!ValidationEmail(inputList[i][inputName].value)) {
                                noErrors = false
                            }
                            break;
                        case "empty":
                            if(!ValidationEmpty(inputList[i][inputName].value)) {
                                noErrors = false
                            }
                            break;
                        case "select":
                            if(!ValidationSelect(inputList[i][inputName])) {
                                noErrors = false
                            }
                            break;
                        case "curp":
                            if(!ValidationCurp(inputList[i][inputName].value)) {
                                noErrors = false
                            }
                            break;
                        case "rfc":
                            if(!ValidationRfc(inputList[i][inputName].value)) {
                                noErrors = false
                            }
                            break;
                        case "validationSize":
                            if(!ValidationZiseStringExact(
                                inputList[i][inputName].value,
                                inputList[i][inputName].limit
                            )) {
                                noErrors = false
                            }
                            break;
                        case "validationSizeStr":
                            if(!ValidationZiseString(
                                inputList[i][inputName].value,
                                inputList[i][inputName].limit
                            )) {
                                noErrors = false
                            }
                            break;
                    }
                } catch (e) {
                }
            }
        }
    }

    return noErrors;
};